// eslint-disable-next-line import/prefer-default-export
export const enabledCategories = ['deposits', 'stocks', 'realEstate', 'loans', 'pension', 'objectsOfValue', 'metals', 'unlistedShares', 'crypto'];
// eslint-disable-next-line import/prefer-default-export
// export const enabledCategories = ['pension', 'realEstate'];
